import React from 'react';
import { IconProps } from '../../types';
import icons from './icons';
import styles from './index.module.css';

const Icon: Component<IconProps> = ({ name, className = '', title, ...props }) => {
  const Component = icons[name];

  if (!Component) {
    return null;
  }

  return (
    <Component
      title={title || name}
      className={`${styles.svg} ${className}`}
      {...props}
    />
  );
};

export default Icon;
